import { render, staticRenderFns } from "./appointmentRecord.vue?vue&type=template&id=5ffd240a&scoped=true&"
import script from "./appointmentRecord.vue?vue&type=script&lang=js&"
export * from "./appointmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./appointmentRecord.vue?vue&type=style&index=0&id=5ffd240a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd240a",
  null
  
)

export default component.exports